import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Label } from '@printdeal/ui-library';

import { OptionProps } from './types/FileDesignTypes';
import DesignOptionCheckbox from './DesignOptionCheckbox';
import DesignOptionsError from './DesignOptionsError';
import { DispatchCategoriesAccount } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface Props {
  fieldName: string;
  title: string;
  options: OptionProps[];
  maxVal: number;
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const DesignOptionsCheckbox = ({
  fieldName,
  title,
  options,
  maxVal = 3,
  dispatchEventCategory = 'order_detail_interaction',
}: Props) => {
  const {
    register,
  } = useFormContext();

  register(`${fieldName}[]`);

  return (
    <>
      <p className="pd-mt-2">
        <Label>{ title } <span className="pd-ml-1 pd-text-error-500" aria-hidden="true">*</span></Label>
        <span className="pd-ml-3 pd-text-dim-500">(max. {maxVal})</span>
      </p>
      <DesignOptionsError fieldName={fieldName} maxVal={maxVal} />
      <div className="pd-grid pd-grid-cols-2 pd-gap-4 sm:pd-grid-cols-3 md:pd-grid-cols-4 lg:pd-grid-cols-5 [&_.gatsby-image-wrapper]:pd-aspect-auto">
        {
          options.map((option) => (
            <DesignOptionCheckbox
              key={option.title}
              fieldName={fieldName}
              option={option}
              dispatchEventCategory={dispatchEventCategory}
            />
          ))
        }
      </div>
    </>
  );
};

export default DesignOptionsCheckbox;
